import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { EmploymentFormGroupData } from '../../../FormData.fi.types';
import { employerIndustryOptions } from '../../config/globals';
import { employerIndustryFieldOption } from './employerIndustryFieldOption';

export const EmployerIndustryField = () => {
  const { t } = useTranslation();

  return (
    <DropdownFieldUI<EmploymentFormGroupData>
      name="LoanApplication/EmployerIndustry"
      label={t('EmployerIndustry.label')}
      data-testid="employer-industry-input"
      options={employerIndustryOptions}
      {...employerIndustryFieldOption}
    />
  );
};
